/* eslint-disable import/no-cycle */
// actions
import { createErrorMsgError } from '../../ErrorMsg/actions';
import superchargers from '../../../data/superchargers.json';

// helpers
import Client from '../../../lib/Client';
import { makeActionCreator } from '../../../lib/Utils';

export const SUPERCHARGERS_FETCH_REQUEST = 'SUPERCHARGERS_FETCH_REQUEST';
const fetchSuperchargersRequest = makeActionCreator(
  SUPERCHARGERS_FETCH_REQUEST,
);

export const SUPERCHARGERS_FETCH_SUCCESS = 'SUPERCHARGERS_FETCH_SUCCESS';
const fetchSuperchargersSuccess = makeActionCreator(
  SUPERCHARGERS_FETCH_SUCCESS,
  'superchargers',
);

export const SUPERCHARGERS_FETCH_FAILURE = 'SUPERCHARGERS_FETCH_FAILURE';
const fetchSuperchargersFailure = makeActionCreator(
  SUPERCHARGERS_FETCH_FAILURE,
  'error',
);

export function fetchSuperchargers() {
  return (dispatch, getState) => {
    dispatch(fetchSuperchargersRequest());

    Client.fetchAllSuperchargers((err, res) => {
      if (err) {
        const { somethingWrong } = getState().ErrorMsg.errors;
        dispatch(fetchSuperchargersFailure(err));
        dispatch(createErrorMsgError(somethingWrong));
      } else {
        // eslint-disable-next-line no-lonely-if
        if (res.body) {
          dispatch(fetchSuperchargersSuccess(res.body.responseObject));
        }
      }
    });
  };
}

export const SUPERCHARGERS_UPDATE_CHARGING = 'SUPERCHARGERS_UPDATE_CHARGING';
export const updateSuperchargersCharging = makeActionCreator(
  SUPERCHARGERS_UPDATE_CHARGING,
  'charging',
);

export const SUPERCHARGERS_HYRDRATE_BODY = 'SUPERCHARGERS_HYRDRATE_BODY';
export const hydrateSuperchargersBody = makeActionCreator(
  SUPERCHARGERS_HYRDRATE_BODY,
  'body',
);

// eslint-disable-next-line operator-linebreak
export const SUPERCHARGERS_UPDATE_ROUTECHARGERS =
  'SUPERCHARGERS_UPDATE_ROUTECHARGERS';
export const updateSuperchargersRoutechargers = makeActionCreator(
  SUPERCHARGERS_UPDATE_ROUTECHARGERS,
  'routechargers',
);

export const SUPERCHARGERS_UPDATE_CHARGERS = 'SUPERCHARGERS_UPDATE_CHARGERS';
export const updateSuperchargersChargers = makeActionCreator(
  SUPERCHARGERS_UPDATE_CHARGERS,
  'noChargers',
);
